<div class="container container-e-service-request">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <h2 class="mt-5 mb-3">
      {{ 'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.TITLE' | translate }}
    </h2>

    <br />

    <section
      class="card mb-4"
      [ngClass]="
        checkInvestorDetailsFormGroupValidOrNotSubmitted()
          ? 'border-dark'
          : 'border-danger border-2'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.INVESTOR_DETAILS_TITLE'
            | translate
        }}
      </div>

      <div class="card-body">
        <app-investor-details
          [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
        ></app-investor-details>
      </div>
    </section>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [controlName]="controlName"
      [submitted]="submitted"
    ></app-proxy-details>

    <section
      class="card mb-4"
      [ngClass]="
        checkEachBuildingPermitTransferFormControlValidOrNotSubmitted()
          ? 'border-dark'
          : 'border-danger border-2'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.BUILDING_PERMIT_TRANSFER'
            | translate
        }}
      </div>

      <div class="card-body">
        <label class="text-nowrap" [attr.for]="controlName.PermitTransferDate">
          {{
            'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.PERMIT_TRANSFER_DATE_TITLE'
              | translate
          }}
        </label>

        <div class="input-group">
          <input
            class="form-control form-control-sm required"
            aria-required="true"
            [attr.placeholder]="'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate"
            [id]="controlName.PermitTransferDate"
            [name]="controlName.PermitTransferDate"
            [formControlName]="controlName.PermitTransferDate"
            ngbDatepicker
            #d="ngbDatepicker"
          />

          <button
            class="btn btn-outline-secondary fa fa-calendar"
            (click)="d.toggle()"
            type="button"
          ></button>
        </div>
        @if (
          shouldShowErrorAlert(
            getBuildingPermitTransferDateFormControl(),
            'required'
          )
        ) {
          <div class="alert alert-danger">
            {{ 'FIELD_REQUIRED' | translate }}
          </div>
        }

        <label [attr.for]="controlName.PermitTransferNumber">
          {{
            'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.PERMIT_TRANSFER_NUMBER_TITLE'
              | translate
          }}
        </label>

        <input
          type="text"
          [name]="controlName.PermitTransferNumber"
          [id]="controlName.PermitTransferNumber"
          class="form-control required mt-2"
          aria-required="true"
          [formControlName]="controlName.PermitTransferNumber"
        />

        @if (
          shouldShowErrorAlert(
            getBuildingPermitTransferNumberFormControl(),
            'required'
          )
        ) {
          <div class="alert alert-danger">
            {{ 'FIELD_REQUIRED' | translate }}
          </div>
        }
      </div>
    </section>

    <section
      class="card mb-4"
      [ngClass]="
        checkIdentificationConstructionIntentValidOrNotSubmitted()
          ? 'border-dark'
          : 'border-danger border-2'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.IDENTIFICATION_CONSTRUCTION_INTENT'
            | translate
        }}
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-12 my-1">
            <label [attr.for]="controlName.BuildingNameAndType">
              {{
                'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.BUILDING_NAME_AND_TYPE'
                  | translate
              }}
            </label>

            <input
              type="text"
              [name]="controlName.BuildingNameAndType"
              [id]="controlName.BuildingNameAndType"
              class="form-control form-control-sm required"
              aria-required="true"
              [formControlName]="controlName.BuildingNameAndType"
            />

            @if (
              shouldShowErrorAlert(
                getBuildingNameAndTypeFormControl(),
                'required'
              )
            ) {
              <div class="alert alert-danger">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            }
          </div>
        </div>

        <div class="mb-4">
          <gk-address-form
            [isRequired]="true"
            [form]="formGroup"
            [idPrefix]="'building-permit'"
          ></gk-address-form>
        </div>

        <gk-map
          [mapState]="mapState"
          (dispatch)="handleMapAction($event)"
        ></gk-map>

        <div class="mt-2">
          @if (mapState.mapObjectTablesState[0].mapObjects.length) {
            <gk-map-object-table
              [mapState]="mapState"
              [mapObjectTableStateIndex]="0"
              (dispatch)="handleMapAction($event)"
            ></gk-map-object-table>
          }
        </div>
      </div>

      @if (submitted && !areParcelsChosen()) {
        <div class="card-footer">
          <div class="alert alert-danger mt-2">
            {{
              'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.PARCELS_REQUIRED'
                | translate
            }}
          </div>
        </div>
      }
    </section>

    <section
      class="card mb-4"
      [ngClass]="
        checkCurrentInvestorDetailsFormGroupValidOrNotSubmitted()
          ? 'border-dark'
          : 'border-danger border-2'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.CURRENT_INVESTOR_DETAILS_TITLE'
            | translate
        }}
      </div>

      <div class="card-body">
        <app-investor-details
          [investorDetailsFromGroup]="getCurrentInvestorDetailsFormGroup()"
          [idPrefix]="'current-investor-details-'"
          [automaticCopyingDataFromPz]="false"
        ></app-investor-details>
      </div>
    </section>

    <app-attachments
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.proxyDetailsVisible"
    >
    </app-attachments>

    <section class="card border-dark mb-4">
      <div class="card-header text-white bg-dark">
        {{
          'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.DECISION_FORM'
            | translate
        }}
      </div>

      <div class="card-body">
        <div class="form-check form-check-inline">
          <input
            type="radio"
            [id]="decisionFormType.NonElectronicForm"
            [attr.name]="controlName.DecisionForm"
            [formControlName]="controlName.DecisionForm"
            [value]="decisionFormType.NonElectronicForm"
            class="form-check-input"
          />

          <label
            class="form-check-label"
            [attr.for]="decisionFormType.NonElectronicForm"
          >
            {{
              'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.NON_ELECTRONIC_FORM'
                | translate
            }}
          </label>
        </div>

        <div class="form-check form-check-inline">
          <input
            type="radio"
            [id]="decisionFormType.ElectronicForm"
            [attr.name]="controlName.DecisionForm"
            [formControlName]="controlName.DecisionForm"
            [value]="decisionFormType.ElectronicForm"
            class="form-check-input"
          />

          <label
            class="form-check-label"
            [attr.for]="decisionFormType.ElectronicForm"
          >
            {{
              'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.ELECTRONIC_FORM'
                | translate
            }}
          </label>
        </div>
      </div>
    </section>

    @if (portalId) {
      <section
        class="card mb-4"
        [ngClass]="
          checkShippingFormGroupValidAndFormSubmitted()
            ? 'border-danger border-2'
            : 'border-dark'
        "
      >
        <div class="card-header text-white bg-dark">
          {{
            'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.SHIPPING_FORM'
              | translate
          }}
        </div>
        <div class="card-body">
          <app-shipping-form
            [shippingFormGroup]="getShippingFormGroup()"
            [decisionForm]="decisionFormValue"
            [portalId]="portalId"
          ></app-shipping-form>
        </div>
      </section>
    }

    <section>
      <div class="card border-dark mb-4">
        <div class="card-header text-white bg-dark">
          {{
            'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.INSTRUCTION'
              | translate
          }}
        </div>

        <div class="card-body">
          <P
            [innerHTML]="
              'BUILDING_PERMIT_TRANSFER.NEW_REQUEST.FIELDS.INSTRUCTION_INFO'
                | translate
            "
          >
          </P>
        </div>
      </div>
    </section>

    <button type="submit" class="btn btn-primary">
      {{
        'ENVIRONMENTAL_PROTECTION_PORTAL.SIMPLIFIED_FOREST_MANAGEMENT_PLAN.FIELDS.SUBMIT_REQUEST'
          | translate
      }}
    </button>

    <div class="d-flex flex-column">
      @if (docSignMsgTxt) {
        <span [ngClass]="'text-' + docSignMsgType">
          {{ docSignMsgTxt }}
        </span>
      }

      @if (docSignUrl) {
        <span class="my-2 text-info">
          {{ docSignTranslations['SIGN_INFO'] }}
        </span>
      }

      @if (docSignUrl) {
        <a class="link" [href]="docSignUrl" target="_blank">
          {{ docSignTranslations['SIGN'] }}
        </a>
      }

      @if (docSignPending) {
        <div class="d-flex justify-content-center my-3">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ 'LOADING' | translate }}</span>
          </div>
        </div>
      }
    </div>

    <div class="mt-2"><app-form-legend></app-form-legend></div>
  </form>
</div>
